
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 9 8","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 7c0 .552.364 1 .813 1h6.5c.448 0 .812-.448.812-1s-.364-1-.813-1h-6.5C.364 6 0 6.448 0 7zM0 4c0 .552.364 1 .813 1h6.5c.448 0 .812-.448.812-1s-.364-1-.813-1h-6.5C.364 3 0 3.448 0 4zM0 1c0 .552.364 1 .813 1h6.5c.448 0 .812-.448.812-1s-.364-1-.813-1h-6.5C.364 0 0 .448 0 1z"}})])
          )
        }
      }
    